import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import useApiPost from "../../../hooks/PostData";
import { updateCurrentConversation } from "../../../store/Slices/CurrentConversationSlice";
import { updateMessageOptions } from "../../../store/Slices/MessageOptionsSlice";
import { updateSendMessageData } from "../../../store/Slices/SendMessageSlice";
import { Message } from "../../../types/MessageListType";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import TextTranslate from "../../../utils/TextTranslate";

export default function ShareLocation({ onClose }: { onClose?: () => void }) {
  const sendMessageData = useAppSelector((state) => state.SendMessageData);
  const { loading, postData } = useApiPost();
  const dispatch = useAppDispatch();
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation,
  );

  const canShare =
    Number.isFinite(Number(sendMessageData.latitude)) &&
    Number.isFinite(Number(sendMessageData.longitude));

  async function shareLocationApiCall() {
    if (!canShare) {
      toast.error("Please select a location");
      return;
    }

    const messageFormData = new FormData();

    if (
      currentConversationData.chat_id != -1 &&
      currentConversationData.chat_id != 0
    ) {
      messageFormData.append(
        "chat_id",
        currentConversationData.chat_id.toString(),
      );
    } else {
      messageFormData.append(
        "user_id",
        currentConversationData.user_id!.toString(),
      );
    }

    messageFormData.append(
      "message_type",
      String(sendMessageData.message_type || "location"),
    );
    messageFormData.append(
      "message_content",
      `${sendMessageData.latitude},${sendMessageData.longitude}`,
    );
    messageFormData.append(
      "other_user_id",
      String(currentConversationData.user_id),
    );

    const sendMessageRes = (await postData(
      "chat/send-message",
      messageFormData,
      "multipart/form-data",
    )) as Message;

    if (!sendMessageRes) return;

    // @ts-ignore
    if (sendMessageRes?.is_block) {
      toast.error(`${currentConversationData.user_name} Blocked You! `);
      return;
    }

    if (
      currentConversationData.chat_id == 0 ||
      currentConversationData.chat_id == -1
    ) {
      dispatch(
        updateCurrentConversation({
          chat_id: sendMessageRes.chat_id,
        }),
      );
    }

    dispatch(updateMessageOptions({ show_send_location_modal: false }));
    dispatch(
      updateSendMessageData({
        message: "",
        message_type: "",
        reply_to: 0,
        latitude: "",
        longitude: "",
      }),
    );
    onClose?.();
  }

  return (
    <div className="absolute inset-x-0 bottom-0 border-t border-black/[0.06] bg-primary/95 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl dark:border-white/[0.08]">
      {sendMessageData.message ? (
        <div className="mb-2 truncate px-1 text-[13px] text-lightText">
          {sendMessageData.message}
        </div>
      ) : null}
      <button
        type="button"
        disabled={!canShare || loading}
        onClick={() => void shareLocationApiCall()}
        className="w-full rounded-xl bg-themeColor py-3.5 text-center text-[17px] font-semibold text-themeTextColor transition active:scale-[0.99] disabled:opacity-50"
      >
        {loading ? (
          <ClipLoader size={18} color="currentColor" />
        ) : (
          <TextTranslate text="Share Location" />
        )}
      </button>
    </div>
  );
}
